import { useState } from 'react';

export default function ShipmentETA() {
  const [form, setForm] = useState({
    order_date: '',
    production_days: '',
    payment_days: '',
    shipping_days: '',
    misc_days: '',
  });
  const [result, setResult] = useState(null);

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + parseInt(days || 0));
    return d;
  };

  const fmt = (date) => date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

  const calculate = () => {
    if (!form.order_date) return;
    const orderDate = new Date(form.order_date);
    const paymentDate = addDays(orderDate, form.payment_days || 0);
    const productionComplete = addDays(paymentDate, form.production_days || 0);
    const shippedDate = addDays(productionComplete, 2);
    const arrivalDate = addDays(shippedDate, form.shipping_days || 0);
    const amazonReadyDate = addDays(arrivalDate, form.misc_days || 0);

    const totalDays = parseInt(form.payment_days || 0) + parseInt(form.production_days || 0) + 2 + parseInt(form.shipping_days || 0) + parseInt(form.misc_days || 0);

    setResult({ orderDate, paymentDate, productionComplete, shippedDate, arrivalDate, amazonReadyDate, totalDays });
  };

  const card = { background: '#fff', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '12px', padding: '1.25rem', marginBottom: '12px' };
  const inp = { width: '100%', padding: '8px 10px', border: '0.5px solid #ddd', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box' };
  const label = { display: 'block', fontSize: '11px', fontWeight: '500', color: '#666', marginBottom: '4px' };

  return (
    <div>
      <div style={card}>
        <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '1rem' }}>Shipment ETA Calculator</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          <div style={{ gridColumn: 'span 2' }}>
            <label style={label}>Order placed date</label>
            <input style={inp} type="date" value={form.order_date} onChange={set('order_date')} />
          </div>
          <div>
            <label style={label}>Payment clearance (days)</label>
            <input style={inp} type="number" placeholder="e.g. 2" value={form.payment_days} onChange={set('payment_days')} />
          </div>
          <div>
            <label style={label}>Production time (days)</label>
            <input style={inp} type="number" placeholder="e.g. 14" value={form.production_days} onChange={set('production_days')} />
          </div>
          <div>
            <label style={label}>Shipping time (days)</label>
            <input style={inp} type="number" placeholder="e.g. 21" value={form.shipping_days} onChange={set('shipping_days')} />
          </div>
          <div>
            <label style={label}>Misc days (handling, delivery to Amazon)</label>
            <input style={inp} type="number" placeholder="e.g. 5" value={form.misc_days} onChange={set('misc_days')} />
          </div>
        </div>
        <button onClick={calculate}
          style={{ width: '100%', marginTop: '1rem', padding: '11px', background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
          Calculate ETA
        </button>
      </div>

      {result && (
        <div style={card}>
          <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '1rem' }}>
            Timeline — Total lead time: <strong>{result.totalDays} days</strong>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
            {[
              { label: 'Order placed', date: result.orderDate, done: true, color: '#1D9E75' },
              { label: 'Payment cleared to supplier', date: result.paymentDate, done: true, color: '#1D9E75' },
              { label: 'Production complete', date: result.productionComplete, done: false, color: '#378ADD' },
              { label: 'Goods shipped', date: result.shippedDate, done: false, color: '#378ADD' },
              { label: 'Arrives at port/destination', date: result.arrivalDate, done: false, color: '#BA7517' },
              { label: 'Ready at Amazon FBA', date: result.amazonReadyDate, done: false, color: '#BA7517' },
            ].map((step, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', paddingBottom: '16px', position: 'relative' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: step.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#fff' }} />
                  </div>
                  {i < 5 && <div style={{ width: '2px', height: '32px', background: '#e0e0e0', marginTop: '4px' }} />}
                </div>
                <div style={{ paddingTop: '1px' }}>
                  <div style={{ fontSize: '13px', fontWeight: '500' }}>{step.label}</div>
                  <div style={{ fontSize: '12px', color: step.color, fontWeight: '500', marginTop: '2px' }}>{fmt(step.date)}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ background: '#EAF3DE', borderRadius: '10px', padding: '14px 16px', marginTop: '8px' }}>
            <div style={{ fontSize: '11px', color: '#3B6D11', fontWeight: '500', marginBottom: '4px' }}>🎯 Expected at Amazon FBA</div>
            <div style={{ fontSize: '22px', fontWeight: '500', color: '#27500A' }}>{fmt(result.amazonReadyDate)}</div>
          </div>
        </div>
      )}
    </div>
  );
}